import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  UpdateRenewalSettings,
  UpdateRenewalSettingsVariables
} from '@/graphql/contracts/_generated_/updateRenewalSettings.mutation';
import UpdateRenewalSettingsMutation from '@/graphql/contracts/updateRenewalSettings.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useUpdateRenewalSettings() {
  const [_updateRenewalSettings, { loading }] = useMutation<UpdateRenewalSettings, UpdateRenewalSettingsVariables>(
    UpdateRenewalSettingsMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: () => notificationService.open({
        title: 'Update Renewal Settings',
        text: 'Renewal Settings successfully updated',
        type: 'success'
      }),
    }
  );

  const updateRenewalSettings = (values: UpdateRenewalSettingsVariables) => {
    return _updateRenewalSettings({
      variables: {
        ...values
      }
    }).then(res => res.data ?? null);
  };

  return {
    updateRenewalSettings,
    isLoadingUpdateRenewalSettings: loading
  } as const;
}
